/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import styled from 'styled-components'
import MarketplaceCard from 'components/public/marketplace/MarketplaceCard'
import PoweredByFocalFooter from 'components/footers/PoweredByFocalFooter'

function PublicRecommendedPackages(props) {
  return (
    <OuterContainer>
      <Row3>
        <H8 fontcolor={props.pack.photographer.fontColor} font={props.pack.photographer.displayFont}>
          Other Recommended Packages
        </H8>
        <Grid>
          {props.otherpacks &&
            props.otherpacks.map((item, index) => {
              return (
                <GridCell key={index}>
                  <MarketplaceCard
                    history={props.history}
                    items={item.images}
                    package={item}
                    recommended={true}
                  />
                </GridCell>
              )
            })}
        </Grid>
        <FooterWrap>
          <PoweredByFocalFooter photographer={props.pack.photographer} />
        </FooterWrap>
      </Row3>
    </OuterContainer>
  )
}

export default PublicRecommendedPackages

const OuterContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--black);
`

const H8 = styled.h4`
  font-size: 26px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--black);
  font-family: ${(props) => props.font && props.font};
  color: ${(props) => (props.fontcolor ? props.fontcolor : 'var(--black')};
  margin: 0 0 10px 10px;
  @media (max-width: 700px) {
    font-size: 22px;
    margin: 0 0 0 10px;
  }
  @media (max-width: 500px) {
    font-size: 20px;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 49% 49%;
  grid-column-gap: 2%;
  grid-row-gap: 1.5em;
  width: 100%;
  padding: 0 2vw;
  @media (max-width: 1250px) {
    grid-template-columns: 100%;
    width: 650px;
  }
  @media (max-width: 700px) {
    padding: 0;
    width: auto;
  }
`

const GridCell = styled.div`
  position: relative;
  border: 1px solid rgb(236, 239, 241);
  font-size: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5em;
  background: white;
  @media (max-width: 700px) {
    align-items: center;
    width: auto;
    padding: 1em;
  }
  @media (max-width: 600px) {
    font-size: 7px;
  }
`

const Row3 = styled.div`
  padding: 2em 0 1em 0;
  margin: 2em 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const FooterWrap = styled.div`
  font-size: 0.65em;
`
